// Styles
import "./_hero-banner--multiple-ctas.scss"

const heroBannerListItems = document.querySelectorAll('.hero-banner__list-item')

function hideListItem(listItem) {
  listItem.getElementsByClassName('hero-banner__list-item--selected')[0].classList.add('hide')
  listItem.getElementsByClassName('hero-banner__list-item--unselected')[0].classList.remove('hide')
}

function showListItem(listItem) {
  listItem.getElementsByClassName('hero-banner__list-item--selected')[0].classList.remove('hide')
  listItem.getElementsByClassName('hero-banner__list-item--unselected')[0].classList.add('hide')
}

function toggleListItem(listItem) {
  if (listItem.getElementsByClassName('hero-banner__list-item--selected')[0].classList.contains('hide')) {
    showListItem(listItem)
  } else {
    hideListItem(listItem)
  }
}

// set the first item as "selected"
const firstListItem = document.querySelector('.hero-banner__list-item.list-number--0')
if (firstListItem) {
  toggleListItem(firstListItem)
}

for (let i = 0; i < heroBannerListItems.length; i++) {
  const currentHeroBannerListItem = heroBannerListItems[i]
  currentHeroBannerListItem.addEventListener('click', (e) => {
    if (!e.target.closest('a')) {
      toggleListItem(currentHeroBannerListItem)

      for (let x = 0; x < heroBannerListItems.length; x++) {
        if (x !== i) {
          hideListItem(heroBannerListItems[x])
        }
      }
    }
  })
}
